import { SUB_APPS } from 'reporting-data/tsTypes/subAppTypes';
import { getDisplayParamsSubAppKey } from 'reporting-data/report/configReportGetters';
import { getCustomWidgetType } from 'reporting-data/report/reportGetters';
import { CUSTOM_WIDGET_TYPES } from 'reporting-data/tsTypes/customWidgetTypes';
import { AGGREGATION } from 'reporting-data/constants/configTypes';
import { setDisplayParamsIntraperiod } from 'reporting-data/report/configReportSetters';
const SUB_APP_KEYS_TO_TRANSPOSE = [SUB_APPS.weightedPipelineForecast];
export const getShouldTransposeVisualization = report => {
  const customWidgetType = getCustomWidgetType(report);
  const isCustomWidgetReport = customWidgetType && customWidgetType !== CUSTOM_WIDGET_TYPES.DATA_LAYER;
  const subAppKey = getDisplayParamsSubAppKey(report);
  if (isCustomWidgetReport || !subAppKey) {
    return false;
  }
  return SUB_APP_KEYS_TO_TRANSPOSE.includes(subAppKey);
};
export const updateIntraperiodForConfigType = (report, value) => {
  const forecastSubAppKeys = [SUB_APPS.weightedPipelineForecast, SUB_APPS.manualForecast];
  if (value === AGGREGATION && forecastSubAppKeys.includes(getDisplayParamsSubAppKey(report))) {
    return setDisplayParamsIntraperiod(report, false);
  }
  return report;
};